import { createSlice } from '@reduxjs/toolkit';
import { fetchUsers, toggleUserStatus, fetchUserById } from '../thunks/userThunks';
import { fetchProfile, updateProfile } from '../thunks/profileThunks';
import { reset } from '../actions/resetActions';

const initialState = {
  users: [],
  user: null,
  profile: null,
  loading: false,
  error: null,
  total: 0,
  currentPage: 1,
  limit: 10,
  success : null,
  canCreateUser: false,

  notificationUnreadCount : 0
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setSuccess : (state, action) => {
      state.success = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(reset, () => initialState)
      // Fetch Users
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload?.data?.users || [];
        state.total = action.payload?.data?.pagination?.total || 1;
        state.currentPage = action.payload?.data?.pagination?.page || 1;
        state.limit = action.payload?.data?.pagination?.limit || 10;
        state.canCreateUser = action.payload?.data?.canCreateUser;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Toggle User Status
      .addCase(toggleUserStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(toggleUserStatus.fulfilled, (state, action) => {
        state.loading = false;
        if (state.users) {
          const updatedUsers = state.users?.map(user => {
            if (user._id === action.payload.data.user._id) {
              return {
                ...user,
                status: action.payload.data.user.status
              };
            }
            return user;
          });
          state.users = updatedUsers;
        }
      })
      .addCase(toggleUserStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch User by ID
      .addCase(fetchUserById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserById.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload?.data?.user;
      })
      .addCase(fetchUserById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Profile
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload?.user;
        state.notificationUnreadCount = action.payload?.notificationUnreadCount;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Profile
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null

      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
        state.success = "Profile Updated !!"
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });
  },
});

export const userAction = usersSlice.actions;
export const userReducer = usersSlice.reducer;